import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import i18n from 'i18next';

import {translation} from '../../store/modules/translation';
import {_NOTICE} from "../../store/modules/notice";
import styled, {useTheme} from "styled-components";
import {Link, NavLink, useHistory, useLocation, useRouteMatch} from "react-router-dom";
import {getRegion, openStoryRegion} from "../../function";
import {PREV_RANKING_LANE} from "../../store/reducer/champions";
import {getOriginalNames} from "../../i18n/languages";
import {LANGUAGE_FOR_OS} from "../../i18n/types";
import ThemeSwitch from "./ThemeSwitch";
import regionList from "../../store/static_json/regionList";
import DownArrow from "./TagWithArrow/DownArrow";
import HeaderSearch from "../Header/HeaderSearch";
import UpArrow from "./TagWithArrow/UpArrow";
import ContentSwitch from "./ContectSwitch";
import ProRequestSwitch from "./ProRequestSwitch";
import {secretApi} from "../../api/api";
import useHover from "../../common/hooks/useHover";
import {MarginBox} from "../ui/styled";


const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
`;
const LogoImg = styled.img`
`;

const SearchWrapper = styled.div`
  flex: 1;
  max-width: 408px;
  z-index: 20003;
`;


const LangWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  z-index: 20001;
  margin-left: 30px;

  .h__util {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;

    .lang {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-left: 15px;
      position: relative;


      button {
        display: flex;
        align-items: center;
        height: 18px;
        font-size: 12px;
        flex: 1;

        &:hover {
          color: ${props => props.theme.color.green_100};
          font-weight: bold;
        }
      }

      ul {
        position: absolute;
        z-index: 10000;
        top: 100%;
        right: 0;
        overflow-x: hidden;
        overflow-y: auto;
        width: 125px;
        max-width: 536px;
        margin-top: 10px;
        padding: 2px 0 4px 0;
        background: ${props => props.theme.color.site_main_color};
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
        border: 1px solid ${props => props.theme.color.default_border_color};
        border-radius: 6px;
      }

      li {
        display: flex;
        align-items: center;
        height: 30px;
        margin: 2px 4px 0;
        padding: 2px 5px;
        font-size: 14px;
        cursor: pointer;
        border-radius: 6px;
        color: ${props => props.theme.color.dark_200};

        &:hover {
          background: ${props => props.theme.color.white_200};
          color: ${props => props.theme.color.dark_100};
        }

        &.selected {
          background-color: ${props => props.theme.color.green_200};
          color: ${props => props.theme.color.green_100};
          font-weight: bold;
        }
      }
    }
  }
`;

const Wrapper = styled.div`
  position: relative;
  z-index: 99999;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: ${props => props.theme.color.site_main_color};
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 10%);
`;

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  z-index: 20000;
`;

const NavWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 64px;
  margin-left: 48px;
`;

const HoverBox = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  z-index: 999999;
  padding: 8px 16px;


  &:hover {
    .arrow-box {
      transform: rotate(180deg);
    }
  }


`;


const NavText = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;


  &.active {
    .bold-span {
      border-radius: 7px;
      color: ${props => props.theme.color.dark_100};
      font-weight: bold;
      opacity: 1;
    }

    .arrow-box {
      transform: rotate(0deg);
    }
  }
`;

const SpecialNavText = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;

  &.active {
    .bold-span {
      border-radius: 7px;
      color: ${props => props.theme.color.dark_100};
      font-weight: bold;
      opacity: 1;
    }

    .arrow-box {
      transform: rotate(0deg);
    }
  }
`;

const BoldSpan = styled.span`
  font-size: 16px;
  color: ${props => props.theme.color.dark_200};
  white-space: nowrap;

  &::after {
    content: attr(title);
    display: block;
    font-weight: bold;
    visibility: hidden;
    height: 0;
  }

  &:hover {
    opacity: 1;
    border-radius: 7px;
    color: ${props => props.theme.color.dark_100};
    font-weight: bold;
  }
`;

const SpecialBoldSpan = styled.span`
  font-size: 16px;
  color: ${props => props.theme.color.dark_200};
  white-space: nowrap;
  font-weight: 700;

  &::after {
    content: attr(title);
    display: block;
    font-weight: bold;
    visibility: hidden;
    height: 0;
  }

  &:hover {
    opacity: 1;
    border-radius: 7px;
    color: ${props => props.theme.color.dark_100};
    font-weight: bold;
  }
`;


const NavColumnText = styled(NavLink)`
  display: block;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};

  &.light + &.light {
    border-top: 1px solid ${props => props.theme.color.default_border_color};
  }

  &.dark + &.dark {
    border-top: 1px solid ${props => props.theme.color.default_border_color};
  }
`;
const ExplainText = styled.div`
  margin-top: 4px;
  font-weight: 400;
  font-size: 10px;
  color: ${props => props.theme.color.dark_200};
  line-height: 100%;
`;


const MaxWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;


const HeaderBox = styled.div`
  padding: 0 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  z-index: 1;
`;

const AbosluteBar = styled.div`
  width: 1px;
  height: 15px;
  background-color: ${props => props.theme.color.default_border_color};
`;

const LangButton = styled.button`
  color: ${props => {
    let color = props.theme.color.dark_100;
    if (props.hover) color = props.theme.color.green_100;
    if (props.open) color = props.theme.color.green_100;
    return color;
  }};

  font-weight: ${props => {
    let weight = 500;
    if (props.hover) weight = 'bold';
    if (props.open) weight = 'bold';
    return weight;
  }};
  @media only screen and (max-width: 1919px) {
    margin-right: 10px;
  }
`;

const LangBox = styled.div`
  @media only screen and (min-width: 1920px) {
    min-width: 118px;
  }
`;
const HeaderAndMarqueeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 108px;
`;


const ArrowDownBox = styled.div`
  width: 24px;
  height: 24px;
  transition-property: transform;
  transition-duration: .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
`;

const BarText = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: ${props => props.theme.color.dark_300};
  margin-right: 8px;
`;
const RowBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const NewIconBox = styled.div`
    display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;
const langArray = ['ENG', 'KOR', 'ja'];
const Header = ({initLoadingNotFound, isHome}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [view, setView] = useState(false);
    const region = useSelector((state) => state.region.result);
    const [openLang, setOpenLang] = useState(false);
    const currentLang = useSelector((state) => state.translation.lang);
    const [isTop, setIsTop] = useState(true);
    const router = useRouteMatch();
    const {pathname} = useLocation();
    useHistory();
    const langRef = useRef(null);
    const theme = useTheme();
    const [hoverRanking, handleRankingMouseOver, handleRankingMouseOut] = useHover();
    const [hoverLang, handleLangMouseOver, handleLangMouseOut] = useHover();
    const [hoverChampion, handleChampionMouseOver, handleChampionMouseOut] = useHover();
    const [hoverContent, handleContentMouseOver, handleContentMouseOut] = useHover();
    const [hoverNav, handleNavMouseOver, handleNavMouseOut] = useHover();
    const location = useLocation()


    useEffect(() => {
        if (pathname.indexOf('/champions') === -1) {
            dispatch({
                type: PREV_RANKING_LANE,
                data: 'top',
            })
        }
    }, [pathname]);

    //
    // useEffect(() => {
    //     if (openView === true) {
    //         setView(openView);
    //         setOpenView(false);
    //     }
    // }, [openView])
    //

    const disaptchNotice = useCallback((data) => {
        dispatch({
            type: _NOTICE,
            data: data,
        })
    }, [])


    useEffect(() => {
        const fetchData = () => {
            secretApi.get(`${process.env.REACT_APP_CACHE_API}common/riot-status?platform_id=${getRegion(region)}`).then((res) => {
                if (!res.data.status) {
                    disaptchNotice('alertError');
                }
            }).catch((e) => {
                const statusCode = e?.response?.status;
                console.log(e);
                if (statusCode === 404) {

                } else if (statusCode === 500) {

                }
            });
        };
        fetchData();
    }, [region]);

    const onChangeLang = (lang) => {
        if (lang === 'KOR') {
            i18n.changeLanguage(LANGUAGE_FOR_OS.ko);
            localStorage.setItem(process.env.REACT_APP_LANG_COOKIE, LANGUAGE_FOR_OS.ko);
        } else if (lang === 'ENG') {
            i18n.changeLanguage(LANGUAGE_FOR_OS.EN);
            localStorage.setItem(process.env.REACT_APP_LANG_COOKIE, LANGUAGE_FOR_OS.EN);
        } else if (lang === 'vi') {
            i18n.changeLanguage(LANGUAGE_FOR_OS.VI);
            localStorage.setItem(process.env.REACT_APP_LANG_COOKIE, LANGUAGE_FOR_OS.VI);
        } else {
            i18n.changeLanguage(lang);
            localStorage.setItem(process.env.REACT_APP_LANG_COOKIE, lang);
        }
        dispatch(translation(lang));
        setOpenLang(false);
    };

    // 언어설정 토글
    const toggleLang = () => {
        setOpenLang((prev) => !prev);
    };

    // 문의하기 열기
    const handleContactOpen = () => {
        setView(true);
    };
    // 문의하기 닫기
    const handleContactClose = () => {
        setView(false);
    };

    // 언어설정 닫기
    const handleClickOutside = useCallback(
        (e) => {
            if (openLang && (!langRef.current || !langRef?.current?.contains(e.target))) setOpenLang(false);
        },
        [openLang]
    );

    const scrollEvent = useCallback(() => {
        if (document.scrollingElement.scrollTop === 0) {
            setIsTop(true);
        } else {
            if (isTop) {
                setIsTop(false);
            }
        }
    }, [isTop])

    useEffect(() => {
        window.addEventListener('scroll', scrollEvent)
        window.addEventListener('click', handleClickOutside);
        return () => {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('scroll', scrollEvent)
        };
    }, [handleClickOutside]);


    const championAramCommonActive = useCallback((pathname) => {
        return pathname.indexOf('summoner') === -1
    }, []);

    const isActiveChampions = useCallback((match, location) => {
        const common = championAramCommonActive(location.pathname);
        const championResult = common && location.pathname.indexOf('/champions') > -1 && location.pathname.indexOf('/aram') === -1 && location.pathname.indexOf('/mastery') === -1 && location.pathname.indexOf('/urf') === -1;
        // const aramCommon = championAramCommonActive(location.pathname);
        // const aramResult = aramCommon && location.pathname.indexOf('/aram') > -1 && pathname.indexOf('daily') === -1;
        // return championResult || aramResult
        return championResult
    }, []);

    const isActiveAram = useCallback((match, location) => {
        const aramCommon = championAramCommonActive(location.pathname);
        const aramResult = aramCommon && location.pathname.indexOf('/aram') > -1 && pathname.indexOf('daily') === -1;
        return aramResult
    }, []);

    // const isActiveURF = useCallback((match, location) => {
    //     const common = championAramCommonActive(location.pathname);
    //     return common && location.pathname.indexOf('/urf') > -1
    // }, []);

    const isActiveMastery = useCallback((match, location) => {
        const common = championAramCommonActive(location.pathname);
        return common && location.pathname.indexOf('/mastery') > -1
    }, []);

    const isActiveRanking = useCallback((match, location) => {
        const common = championAramCommonActive(location.pathname);
        const rankingResult = common && location.pathname.indexOf('/ranking') > -1
        const masteryResult = isActiveMastery(match, location)
        const dailyResult = isActiveDailyRanking(match, location)
        const lckResult = common && location.pathname.indexOf('/lck') > -1
        return rankingResult || masteryResult || dailyResult || lckResult
    }, []);

    const isActiveDailyRanking = useCallback((match, location) => {
        const common = championAramCommonActive(location.pathname);
        return common && location.pathname.indexOf('/daily/ai') > -1
    }, []);

    const isActiveContent = useCallback((match, location) => {
        const common = championAramCommonActive(location.pathname);
        const tracker = common && location.pathname.indexOf('/tracker') > -1
        const sllResult = common && location.pathname.indexOf('/sll') > -1
        const mangResult = common && location.pathname.indexOf('/mang') > -1

        return tracker || sllResult || mangResult

    }, []);

    const filteredRankRegion = useMemo(() => {
        const current = regionList.find((data) => data.title === region);
        if (current?.rank) {
            return current.title.toLowerCase()
        } else {
            return regionList[0].title.toLowerCase();
        }
    }, [region]);


    return (
        <HeaderAndMarqueeWrapper id={'menu-container'}>
            <Wrapper>
                <HeaderBox>

                    <LogoWrapper>
                        <Link to="/" data-testId={'header-logo'}>
                            <LogoImg src={`${theme.icon.path}/deeplol_logo_fall_2026.png`} width={160}/>
                            {/*<LogoImg src={`${theme.icon.path}/deeplol_10_main.png`} width={160}/>*/}
                        </Link>
                    </LogoWrapper>

                    <CenterWrapper>
                        <MaxWrapper>
                            <FlexWrapper>
                                <NavWrapper onMouseOver={handleNavMouseOver} onMouseLeave={handleNavMouseOut}>
                                    {/*<NavText exact to="/">{t('header.navHome')}</NavText>*/}
                                    {/*<NavText to="/summoner">{t('header.navSummoner')}</NavText>*/}
                                    {/*{currentLang === 'KOR' &&*/}

                                    {/*    <FlexBox>*/}
                                    {/*        <EmptyBox>*/}

                                    {/*            <NavTextMargin to={'/event'}>*/}
                                    {/*                <img src={`${theme.icon.path}/mang/logo_mang.svg`} height={30}/>*/}
                                    {/*            </NavTextMargin>*/}
                                    {/*        </EmptyBox>*/}
                                    {/*    </FlexBox>*/}
                                    {/*}*/}
                                    <NavText to="/champions" isActive={isActiveChampions}>
                                        <HoverBox onMouseOver={handleChampionMouseOver}
                                                  onMouseLeave={handleChampionMouseOut}>
                                            <BoldSpan
                                                title={t('header.navChampions') + "1"}
                                                className={'bold-span'}>{t('header.navChampions')}</BoldSpan>
                                            <ArrowDownBox className={'arrow-box'}>
                                                <img
                                                    src={`${theme.icon.path}/header/header_down_arrow${isActiveChampions('', location) ? "_selected" : ""}.svg`}
                                                    width={24}
                                                    height={24} alt={''}/>
                                            </ArrowDownBox>
                                        </HoverBox>
                                    </NavText>
                                    {/*<NavTextMargin to="/aram"*/}
                                    {/*               isActive={isActiveAram}*/}
                                    {/*               title={t('header.navAram') + "1"}>{t('header.navAram')}</NavTextMargin>*/}
                                    {/*<MaintainTag><ScaleFont>점검중</ScaleFont></MaintainTag>*/}
                                    <NavText to={`/ranking/${filteredRankRegion}/all`} isActive={isActiveRanking}>
                                        <HoverBox onMouseOver={handleRankingMouseOver}
                                                  onMouseLeave={handleRankingMouseOut}>
                                            <BoldSpan
                                                title={t('header.navRanking') + "1"}
                                                className={'bold-span'}>{t('header.navRanking')}</BoldSpan>
                                            <ArrowDownBox className={'arrow-box'}>
                                                <img
                                                    src={`${theme.icon.path}/header/header_down_arrow${isActiveRanking('', location) ? '_selected' : ""}.svg`}
                                                    width={24}
                                                    height={24} alt={''}/>
                                            </ArrowDownBox>
                                        </HoverBox>
                                    </NavText>
                                    {/*<NavText to="/multi">{t('header.navMulti')}</NavText>*/}
                                    {(openStoryRegion(region) && currentLang === 'KOR') &&
                                        <NavText to="/mgh" isActive={isActiveContent}>
                                            <HoverBox onMouseOver={handleContentMouseOver}
                                                      onMouseLeave={handleContentMouseOut}>
                                                <BoldSpan title={t('header.content') + "1"} className={'bold-span'}>
                                                    <span>{t('header.content')}</span>
                                                </BoldSpan>
                                                <ArrowDownBox className={'arrow-box'}>
                                                    <img
                                                        src={`${theme.icon.path}/header/header_down_arrow${isActiveContent('', location) ? '_selected' : ""}.svg`}
                                                        width={24}
                                                        height={24} alt={''}/>
                                                </ArrowDownBox>
                                            </HoverBox>
                                        </NavText>
                                    }
                                    <SubHeader
                                        hoverRanking={hoverRanking}
                                        hoverNav={hoverNav}
                                        hoverChampion={hoverChampion}
                                        hoverContent={hoverContent}
                                    />

                                </NavWrapper>
                                <NewIconBox>
                                    {currentLang === 'KOR' &&
                                        <RowBox>
                                            <BarText>|</BarText>
                                            <SpecialNavText to={'/connect'}
                                                            isActive={() => location.pathname === '/connect'}>
                                                <MarginBox margin={'0 8px 0 0'}>
                                                    <img src={`${theme.icon.path}/connect/icon_connect_vertical.svg`}
                                                         width={12}
                                                         alt={''}/>
                                                </MarginBox>
                                                <SpecialBoldSpan title={"CONNECT"} className={'bold-span'}>
                                                    CONNECT
                                                </SpecialBoldSpan>
                                                <NewBox/>
                                            </SpecialNavText>
                                        </RowBox>}
                                    {/*{currentLang === 'KOR' &&*/}
                                    {/*    <RowBox>*/}
                                    {/*        <BarText>|</BarText>*/}
                                    {/*        <SpecialNavText to={'/mgh'}*/}
                                    {/*                        isActive={() => location.pathname === '/event'}>*/}
                                    {/*            <SpecialBoldSpan title={"결망전"} className={'bold-span'}>*/}
                                    {/*                결망전*/}
                                    {/*            </SpecialBoldSpan>*/}
                                    {/*        </SpecialNavText>*/}
                                    {/*    </RowBox>}*/}
                                </NewIconBox>
                            </FlexWrapper>
                        </MaxWrapper>
                    </CenterWrapper>
                    <SearchWrapper>
                        {!isHome && <HeaderSearch initLoadingNotFound={initLoadingNotFound} key={router.url}/>}
                    </SearchWrapper>
                    <LangWrapper>
                        <div className="h__util">
                            <ProRequestSwitch/>
                            <ContentSwitch/>
                            <ThemeSwitch/>
                            <AbosluteBar/>
                            <LangBox className="lang" ref={langRef} onClick={toggleLang}
                                     onMouseOver={handleLangMouseOver}
                                     onMouseOut={handleLangMouseOut}>
                                <LangButton open={openLang}
                                            isHover={hoverLang}>{getOriginalNames(currentLang)}</LangButton>
                                {openLang ?
                                    <UpArrow size={4} color={theme.color.green_100}/>
                                    :
                                    <DownArrow size={4}
                                               color={hoverLang ? theme.color.green_100 : theme.color.dark_100}/>
                                }
                                {openLang && (
                                    <ul>
                                        {langArray.map((data) => {
                                            return (
                                                <li
                                                    key={data}
                                                    className={`${currentLang === data && 'selected'}`}
                                                    onClick={() => onChangeLang(data)}
                                                >
                                                    {getOriginalNames(data)}
                                                </li>
                                            )

                                        })}

                                    </ul>
                                )}
                            </LangBox>
                        </div>
                    </LangWrapper>
                </HeaderBox>
            </Wrapper>
        </HeaderAndMarqueeWrapper>
    )
        ;
};


const SubHeaderWrapper = styled.div`
  border-radius: 6px;
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 1;
  background-color: ${props => props.theme.color.site_main_color};
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 10%);
  overflow: hidden;
  animation-fill-mode: forwards;

  &.animate-in {
    animation-name: enter;
    animation-duration: .15s;;
  }

  &.exit {
    animation-fill-mode: forwards;
    animation-name: exit;
    animation-duration: .15s;
  }


  @keyframes enter {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1)
    }
  }

  @keyframes exit {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      display: none;
      opacity: 0;
      transform: scale(0.9)
    }
  }


`;
const EmptyLeft = styled.div`
  width: 175px;
`;
const EmptyRight = styled.div`
  width: 630px;
`;
const NavColumn = styled.div`
  width: 100%;
`;

const NavColumnWrapper = styled.div`
  width: 316px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
`;

const AbsoluteBox = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
`;

const SubHeaderItemBox = styled.div`
  width: 316px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 11px 8px 16px;
`;

const ComingSoonBox = styled(SubHeaderItemBox)`
  height: 56px;
  border-top: 1px solid ${props => props.theme.color.default_border_color};
`;

const SubHeaderImageBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  animation-fill-mode: forwards;

`;

const ComingSoonImageBox = styled.div``;

const SubHeaderInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${props => props.theme.color.site_main_color};
  left: 50px;
  width: 241px;
  margin-left: 16px;
  height: 40px;

`;


const SubHeaderText = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${props => props.theme.color.dark_100};

`;

const ComingSoonText = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
  white-space: pre-wrap;
`;


const VisibleBox = styled.div`
  width: 32px;
  height: 32px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const LeftSlide = styled.div`
  width: 32px;
  position: absolute;
  left: -32px;
`;
const SubHeader = ({hoverNav, hoverContent, hoverChampion, hoverRanking}) => {
        const {t} = useTranslation();
        const {pathname} = useLocation();
        const theme = useTheme();
        const region = useSelector((state) => state.region.result);
        const [prev, setPrev] = useState([]);
        const [list, setList] = useState([]);
        const [motion, setMotion] = useState('pause')
        const currentLang = useSelector((state) => state.translation.lang);

        const filteredRankRegion = useMemo(() => {
            const current = regionList.find((data) => data.title === region);
            if (current?.rank) {
                return current.title.toLowerCase()
            } else {
                return regionList[0].title.toLowerCase();
            }
        }, [region]);

        const rankingSubList = [
            {
                to: `/ranking/${filteredRankRegion}/all`,
                title: t('tabs.rankedSolo'),
                img: 'header_rank',
                explain: t('header.rankExplain')

            },
            {
                to: '/mastery',
                title: t('header.navMastery'),
                img: 'header_mastery',
                explain: t('header.masteryExplain')

            },
            {
                to: '/lck/all',
                title: t('lck.header'),
                img: 'header_pro',
                explain: t('header.proExplain')
            }
        ]
        const contentSubList =
            currentLang === 'KOR' ?

                [  {
                    to: '/event',
                    title: "2026 멸망전",
                    img: 'header_mang2',
                    explain: '딥롤이 후원한 2026 SOOP 멸망전 경기 결과를 확인하세요.'
                },{
                    to: '/soop/tierrun',
                    title: "SOOP X DEEPLOL 티어런",
                    img: 'soop_logo',
                    explain: 'SOOP과 딥롤이 함께 준비한 2026년 티어런 이벤트를 확인하세요.'
                }, {

                    to: '/segucup',
                    title: "2026 쇠구컵",
                    img: 'header_gosegu',
                    explain: '이세계 아이돌 고세구가 주최하고 딥롤이 지원한 저티어 대회 \n' +
                        '쇠구컵 2026을 확인하세요.'
                }, {
                    to: '/mgh',
                    title: "2026 결망전",
                    img: 'header_mgh',
                    explain: '저티어를 위한 결망전 4회차 결과를 확인하세요.'
                },{
                    to: '/sll/winter',
                    title: "2025 SLL",
                    img: 'header_sll',

                    explain: t('header.sllExplain')
                },
                    // }, {
                    //     to: 'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6?pvs=4',
                    //     title: "응원배너광고",
                    //     img:'header_rift.svg',
                    // },]
                ] : [
                    {
                        to: '/story',
                        title: t('header.deeplolStory'),
                        img: 'header_story',
                        explain: t('header.storyExplain')

                    },

                ]
        const championSubList = [
            {
                to: '/champions',
                title: t('header.navSummonerRift'),
                img: 'header_rift',
                explain: t('header.riftExplain')

            },
            {
                to: '/aram',
                title: t('header.navAram'),
                img: 'header_aram',
                explain: t('header.aramExplain')

            },
            {
                to: '/llm',
                title: t('llm.header'),
                img: 'header_llm',
                explain: t('header.llmExplain')

            }
        ]

        useEffect(() => {
            if (hoverChampion) {
                setList(championSubList);
            } else if (hoverRanking) {
                setList(rankingSubList)
            } else if (hoverContent) {
                if (currentLang === 'KOR') {
                    setList(contentSubList)
                }
            }
        }, [hoverRanking, hoverContent, hoverChampion, currentLang]);


        useEffect(() => {
            if (!hoverNav) {
                setTimeout(() => {
                    setPrev([])
                    setList([])
                    setMotion('pause')
                }, 150);
            }
        }, [hoverNav]);

        return (
            <AbsoluteBox>
                <SubHeaderWrapper hover={hoverNav} className={`${hoverNav ? 'animate-in' : "exit"} `}>

                    <NavColumnWrapper>

                        <NavColumn>
                            {list.map((data, index) => {

                                return (
                                    <NavColumnText to={data.to} key={index} className={theme.color.theme}>
                                        <SubHeaderItemBox>
                                            <SubHeaderImageBox>
                                                <VisibleBox>

                                                    <div>
                                                        <img
                                                            src={`${theme.icon.path}/header/${data.img}.svg`}
                                                            width={32}/>
                                                    </div>

                                                </VisibleBox>
                                            </SubHeaderImageBox>
                                            <SubHeaderInfoBox>
                                                <SubHeaderText>{data.title}</SubHeaderText>
                                                <ExplainText>
                                                    {data.explain}
                                                </ExplainText>
                                            </SubHeaderInfoBox>
                                        </SubHeaderItemBox>
                                    </NavColumnText>
                                )
                            })}

                        </NavColumn>
                    </NavColumnWrapper>
                </SubHeaderWrapper>
            </AbsoluteBox>
        );
    }
;


const RotationHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
`;
const RotateSpan = styled.span`
  color: ${props => props.theme.color.dark_200};
  font-size: 16px;
  font-weight: 500;
  margin-left: 9px;
`;
const RotationHeader = () => {
    const currentLang = useSelector((state) => state?.translation.lang);
    const {t} = useTranslation()
    const rotate = useMemo(() => {
        if (currentLang !== 'KOR') {
            return 0;
        }
        const item = Number(localStorage.getItem('headerRotate') ?? 0);
        let next = item + 1
        if (item >= 4) {
            next = 1
            localStorage.setItem('headerRotate', '1');
        } else {
            localStorage.setItem('headerRotate', `${next}`);
        }
        return next
    }, [])

    if (currentLang !== 'KOR') {
        return null
    }


    if (rotate === 1) {
        return (
            <a href={'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6'} target={"_blank"}>
                <RotationHeaderWrapper>
                    <img src={'./images/icon_cake.webp'} width={26} alt={''}/>
                    <RotateSpan>{t('gnb.cake')}</RotateSpan>
                </RotationHeaderWrapper>
            </a>
        )
    }
    if (rotate === 2) {
        return (
            <a href={'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6'} target={"_blank"}>
                <RotationHeaderWrapper>
                    <img src={'./images/icon_siren.svg'} width={26} alt={''}/>
                    <RotateSpan>{t('gnb.streamer')}</RotateSpan>
                </RotationHeaderWrapper>
            </a>
        )
    }
    if (rotate === 3) {
        return (
            <a href={'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6'} target={"_blank"}>
                <RotationHeaderWrapper>
                    <img src={'./images/icon_discord.svg'} width={26} alt={''}/>
                    <RotateSpan>{t('gnb.discord')}</RotateSpan>
                </RotationHeaderWrapper>
            </a>
        )
    }
    if (rotate === 4) {
        return (
            <a href={'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6'} target={"_blank"}>
                <RotationHeaderWrapper>
                    <img src={'./images/icon_party.svg'} width={26} alt={''}/>
                    <RotateSpan>{t('gnb.party')}</RotateSpan>
                </RotationHeaderWrapper>
            </a>
        )
    }

    return (
        <a href={'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6'} target={"_blank"}>
            <RotationHeaderWrapper>
                <img src={'./images/icon_cake.webp'} width={26} alt={''}/>
                <RotateSpan>{t('gnb.cake')}</RotateSpan>
            </RotationHeaderWrapper>
        </a>
    )
}

const NewBoxWrapper = styled.div`
  margin-left: 4px;
  width: 18px;
  height: 18px;
`;
const NewBox = () => {
    return (
        <NewBoxWrapper>
            <img
                src={'/images/new_badge.svg'}
                width={18}
                height={18}
                alt={""}
            />
        </NewBoxWrapper>
    )
}


export default Header;
